module.exports = __webpack_public_path__ + "images/ui/bg_trapezoid_a7a8785cba6b2024c2d5a3983dd55410.svg";